import { Separator } from '@/components/ui/separator'
import { Skeleton } from '@/components/ui/skeleton'

type Props = {
  hasFooter?: boolean
}

export const AppBoxFallback = ({ hasFooter = false }: Props) => {
  return (
    <div className="border rounded-lg bg-[var(--color-background)] hover:shadow-md transition-all">
      <div>
        <div className="p-4 gap-1 flex flex-col w-full">
          <div className="flex gap-1 justify-between items-center flex-nowrap">
            <Skeleton className="h-4 w-[150px]" />
            <Skeleton className="h-6 w-8" />
          </div>
          <Skeleton className="h-4 w-[250px]" />
        </div>
      </div>
      <Separator />
      <div className="p-4 space-y-2">
        <div className="flex flex-nowrap gap-2 items-center">
          <Skeleton className="h-4 w-[150px]" />
          <Skeleton className="h-4 w-[80px]" />
        </div>
        <div className="flex flex-nowrap gap-2 items-center">
          <Skeleton className="h-4 w-4" />
          <Skeleton className="h-4 w-[80px]" />
          <Skeleton className="h-4 w-[80px]" />
        </div>
      </div>
      {hasFooter ? (
        <>
          <Separator />
          <div className="p-4">
            <Skeleton className="h-9 w-full" />
          </div>
        </>
      ) : null}
    </div>
  )
}
